<template>
  <div class="activity_entries_container">
    <div class="back">
      <span class="back-arrow" @click="$router.back(-1)">
        <Icon iconClass="arrow-left2" />
      </span>
      <span>参赛作品</span>
    </div>
    <div class="entries_category" v-if="categoryList.length > 1">
      <van-tabs class="entries_category_tabs" @click="onTabClick" v-model="selectedIndex" swipe-threshold="2" :line-width="lineWidth">
        <van-tab v-for="item in categoryList" :title="item.label" :key="item.tabType">
        </van-tab>
      </van-tabs>
    </div>
    <div class="entries_search">
      <div class="search_bar">
        <input type="text" placeholder="请输入您要搜索的作者姓名..." @keyup.enter="search" v-model="searchKey" />
      </div>
    </div>
    <div class="entries_body">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :offset="10" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
          <ul class="entries_list clearfix">
            <li class="entries_item" v-for="(item,index) in entriesList" :key="index">
              <div class="entries_img_box" @click="toEntriyDetail(item)">
                <div class="img">
                  <img :src="item.applyFormProfile" alt="" v-if="!!item.applyFormProfile && item.applyFormProfile.length>0" />
                  <img :src="item.pictures[0].url" alt="" v-else-if="!!item.pictures && item.pictures.length>0" />
                  <img :src="item.video[0].coverUrl" alt="" v-else-if="!!item.video && item.video.length>0" />
                </div>
                <div class="num"><span v-text="item.serialNumber"></span>号</div>
              </div>
              <div class="entries_text">
                <span class="name" v-text="item.memberNickName"></span>
                <span class="vote">
                  <van-icon name="like-o" />{{item.supportCount}}票
                </span>
              </div>
              <span class="vote_btn" @click="vote($event,item)">为TA投票</span>
            </li>
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import activityApi from "@/api/apis/activity.js";
import commApi from "@/api/apis/common.js";
export default {
  name: "Entries",
  data() {
    return {
      activityParams: {
        contentType: 1,
        activityId: null,
        cId: 0,
      },
      activityDetail: null,
      categoryList: [], // 排序tabs
      sortTypeList: { 'comment': 1, 'live': 2, 'tw': 4 },
      selectedIndex: 0,
      lineWidth: 0, //Tab标签底部条宽度
      refreshing: false,
      loading: false,
      finished: false,
      searchKey: "",
      params: {
        activityId: null,
        sortType: 1,
        pageNo: 0,
        pageSize: 10,
        keywords: "",
      },
      entriesList: [],
      entriesTotal: 0,
      pageCount: 0,
      loadFirstPage: true, //是否加载第一页,用来解决vant上拉加载本身的缺陷问题
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.activityDetail.activityName + " - 法治号客户端", "参赛作品列表", location.href, _this.activityDetail.sharePictureUrl);
      }).catch((err) => {

      })
    },
    /* 获取活动详情 */
    getActivityDetail() {
      var _this = this;
      activityApi
        .getActivityDetail(_this.activityParams)
        .then((res) => {
          if (res.suc == 1) {
            _this.activityDetail = res.data;
            res.data.tabPages.forEach(function (dataItem, i) {
              if (dataItem.checkStat) {
                _this.categoryList.push(dataItem);
              }
            });
            if (_this.categoryList.length >= 1) {
              _this.params.sortType = _this.sortTypeList[_this.categoryList[0].category];
              _this.lineWidth = _this.categoryList[0].label.length * 14;
            } else {
              _this.params.sortType = 1;
            }
            _this.getEntriesByActivityId(); //获取参赛作品列表
            _this.wechatShare(); // 微信二次分享
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 切换分类 */
    onTabClick(index) {
      var _this = this;
      _this.selectedIndex = index;
      _this.params.sortType = _this.sortTypeList[_this.categoryList[index].category];
      _this.lineWidth = _this.categoryList[index].label.length * 14;
      _this.params.pageNo = 0;
      _this.entriesList = [];
      _this.entriesTotal = 0;
      _this.pageCount = 0;
      _this.loadFirstPage = true;
      if (_this.finished) {
        _this.refreshing = false;
      } else {
        _this.refreshing = true;
      }
      _this.loading = false;
      _this.finished = false;
      _this.getEntriesByActivityId(); // 获取参赛作品列表
    },
    /* 获取参赛作品列表 */
    getEntriesByActivityId() {
      var _this = this;

      activityApi
        .listApplyFormByActivityId(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            if (_this.params.pageNo == 0) {
              _this.entriesList = res.data.applyFormList;
            } else {
              _this.entriesList = _this.entriesList.concat(
                res.data.applyFormList
              );
            }
            _this.entriesTotal = res.data.count;
            _this.pageCount = Math.ceil(res.data.count / _this.params.pageSize);
            if (_this.params.pageNo >= _this.pageCount - 1) {
              _this.finished = true;
            }
            _this.loadFirstPage = false;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 下拉刷新 */
    onRefresh() {
      this.params.pageNo = 0;
      // this.entriesList = [];
      this.entriesTotal = 0;
      this.pageCount = 0;
      this.loadFirstPage = true;
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      this.getEntriesByActivityId(); //获取参赛作品列表
    },
    /* 上拉加载 */
    onLoadMore() {
      if (!this.loadFirstPage) {
        this.params.pageNo++;
        if (this.params.pageNo < this.pageCount) {
          this.loading = true;
          this.getEntriesByActivityId(); //获取参赛作品列表
        }
      }
    },
    /* 搜索 */
    search() {
      this.params.pageNo = 0;
      this.params.keywords = this.searchKey;
      this.entriesList = [];
      this.entriesTotal = 0;
      this.pageCount = 0;
      this.loadFirstPage = true;
      this.refreshing = false;
      this.loading = false;
      this.finished = false;
      this.getEntriesByActivityId(); //获取参赛作品列表
    },
    /* 投票 */
    vote(event, data) {
      var _this = this;

      if (!_this.userInfo) {
        _this.$router.push("/login");
        return;
      }

      var clsArray = event.currentTarget.classList;
      if (clsArray.contains("voted_btn")) {
        return;
      }

      var params = {
        applyFormId: data.applyFormId,
        memberId: _this.userInfo.id,
        voteSourceType: 1, //来源的客户端  1、分享页     2、app
      };
      activityApi
        .topApplyForm(params)
        .then((res) => {
          if(res.suc==1){
            data.supportCount = data.supportCount + 1;
            clsArray.add("voted_btn");
          }
          if (res.suc == 0) {
            clsArray.add("voted_btn");
          }
          _this.$toast({
            message: res.message || res.text,
            position: "center",
          });
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 跳转作品详情 */
    toEntriyDetail(data) {
      this.$router.push({
        path: "/entriy_detail",
        query: {
          applyFormId: data.applyFormId,
          contentType: "activity_work_detail",
        },
      });
    },
  },
  created() {
    document.title = "参赛作品";
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "activityId")) {
      this.params.activityId = query.activityId;
      this.activityParams.activityId = query.activityId;
      this.activityParams.contentType = Number(query.contentType) || 1;
      this.activityParams.cId = Number(query.cId) || 0;
      this.getActivityDetail(); //获取活动详情
      loadStat(); // 友盟统计
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.activity_entries_container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .entries_category {
    background-color: #fff;
    .entries_category_tabs {
      /deep/.van-tabs__wrap {
        height: 40px;
        .van-tabs__nav--line {
          padding: 0;
          .van-tabs__line {
            bottom: 0;
          }
        }
      }
    }
  }
  .entries_search {
    background-color: #f6f6f6;
    .search_bar {
      padding: 15px;
      input {
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding-left: 30px;
        padding-right: 15px;
        background-repeat: no-repeat;
        background-position: left 12px top 7px;
        background-size: 15px auto;
        background-image: url(~@/assets/images/icon_search.png);
        border: none;
        outline: none;
        border-radius: 15px;
      }
    }
  }
  .entries_body {
    flex: 1;
    background-color: #f6f6f6;
    overflow-x: hidden;
    overflow-y: auto;
    .entries_list {
      padding: 0 10px;
      .entries_item {
        float: left;
        position: relative;
        width: calc(50% - 10px);
        background-color: #fff;
        margin: 5px;
        overflow: hidden;
        border-radius: 5px;
        .entries_img_box {
          position: relative;
          width: 100%;
          height: 0;
          padding-bottom: 100%;
          overflow: hidden;
          .img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            text-align: center;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            background-image: url(~@/assets/images/default_pic_1_1.png);
            display: flex;
            justify-content: center;
            img {
              display: block;
              object-fit: cover;
              min-width: 100%;
              min-height: 100%;
              margin: auto;
            }
          }
          .num {
            position: absolute;
            left: 0;
            top: 0;
            padding: 3px 10px;
            color: #fff;
            font-size: 12px;
            background-color: rgba(0, 0, 0, 0.3);
            border-top-left-radius: 5px;
            border-bottom-right-radius: 5px;
          }
        }
        .entries_text {
          padding: 20px 12px 15px;
          line-height: 21px;
          .name {
            color: #333;
            font-size: 14px;
          }
          .vote {
            float: right;
            color: #397ef5;
            font-size: 12px;
          }
        }
        .vote_btn {
          position: absolute;
          bottom: 41px;
          left: 20%;
          display: block;
          width: 60%;
          height: 32px;
          line-height: 32px;
          background: -webkit-linear-gradient(#41adfe, #037efd);
          background: -o-linear-gradient(#41adfe, #037efd);
          background: -moz-linear-gradient(#41adfe, #037efd);
          background: linear-gradient(#41adfe, #037efd);
          text-align: center;
          color: #fff;
          font-size: 14px;
          border-radius: 5px;
          &.voted_btn {
            background: #99bbdb;
          }
        }
      }
    }
  }
}
</style>